<template>
  <div>

    <Spinner v-if="loading === true" />

    <div
        v-if="loading === false"
        class="row"
    >
      <div class="col-md-6" />
      <div class="col-md-6 create-button">
        <button
            id="deleteMultiple"
            type="button"
            class="btn btn-outline-primary mb-2"
            @click="confirmDeleteText(deletedArry)"
        >
          Delete Selected Elements
        </button>
        <button
            type="button"
            class="btn btn-primary mb-2 ml-1"
            data-toggle="modal"
            data-target="#createModal"
        >
          Create
        </button>
        <create
            v-if="$router.currentRoute.name === 'representative'"
            @refresh="getRepresentatives()"
        />
      </div>
    </div>
    <basic-table
        v-if="loading === false"
        ref="table"
        :columns="columns"
        :values="rows"
        :actions-obj="actionsArray"
        @dynamicAction="handleActions($event)"
        @choosenObject="getEditedObject($event)"
        @deleteItems="removeItems($event)"
        @deletedMultipleIds="catchIds($event)"
    />
    <edit
        v-if="$router.currentRoute.name === 'representative'"
        :representative="editedRepresentative"
        @refresh="getRepresentatives()"
    />
    <ResetPassword
        :client="clientId"
        @refresh="renderTable"
    />
  </div>
</template>
<script>
import { BRow, BCol } from 'bootstrap-vue'
import BasicTable from '../../../shared/tables/BasicTable.vue'
import Create from './create.vue'
import Edit from './edit.vue'
import representativesService from '../../../services/representativesService'
import ResetPassword from './resetPassword.vue'
import Spinner from '@/shared/loader/Spinner.vue'

export default {
  components: {
    Spinner,
    BRow,
    BCol,
    ResetPassword,
    Create,
    Edit,
    BasicTable,
  },
  data() {
    return {
      loading: false,
      actionsArray: [{ title: 'Change Role', icon: 'Edit3Icon' }, { title: 'Reset Password', icon: 'KeyIcon'}],
      editedRepresentative: '',
      clientId: '',
      columns: [

        {
          label: 'Full Name',
          field: 'full_name',
        },
        {
          label: 'Phone',
          field: 'phone_number',
        },
        {
          label: 'Email',
          field: 'email',
        },
        {
          label: 'E-Id',
          field: 'eid_number',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',
    }
  },
  created() {
    this.getRepresentatives()
  },
  methods: {
    getRepresentatives() {
      this.loading = true
      representativesService.index().then(response => {
        this.rows = response.data.data
        this.loading = false
      })
    },
    handleActions(itemObj) {
      switch (itemObj.key) {
        case 'Change Role':
          this.changeRole(itemObj.id)
          break
        case 'Reset Password': {
          this.clientId = itemObj.id
          $('#resetPasswordModal').modal('show')
        }
          break
        default:
          console.log('Action Object *******>', itemObj)
      }
      // this.$router.push({ name: 'representatives', params: { id: itemId } })
    },
    getEditedObject(obj) {
      this.editedRepresentative = obj
      console.log('this.editedRepresentative', this.editedRepresentative)

    },
    catchIds(ids) {
      this.deletedArry = ids
    },
    removeItems(arr) {
      this.loading = true
      this.confirmDeleteText(arr)
    },
    confirmDeleteText(arr) {
      if (arr.length > 0) {
        this.$swal({
          title: 'Are you sure?',
          text: "You won't be able to revert this!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, delete it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            representativesService.delete(arr.join()).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Deleted!',
                  text: 'Your Items have been deleted.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.renderTable()
                })
              }
            }).catch(error => {
              this.loading = false
              return Promise.reject(error)
            })
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    },
    confirmChangeRoleText(id) {
      if (id !== null && id !== undefined) {
        this.$swal({
          title: 'Are you sure of changing this representative to client role?',
          text: '',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, change it!',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            representativesService.changeRole(id).then(response => {
              if (response && response.status === 200) {
                this.$swal({
                  icon: 'success',
                  title: 'Role Changed!',
                  text: 'Role Has Changed Successfully.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(() => {
                  this.renderTable()
                })
              }
            }).catch(error => {
              this.loading = false
              return Promise.reject(error)
            })
          } else if (result.dismiss === 'cancel') {
            this.$swal({
              title: 'Cancelled',
              text: '',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    },
    changeRole(id) {
      this.loading = true
      this.confirmChangeRoleText(id)
    },
    renderTable() {
      this.getRepresentatives()
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
